import PropTypes from 'prop-types';
import React, {Fragment, memo} from 'react';
import {Avatar as MuiAvatar, Tooltip} from '@mui/material';
import {Person as PersonIcon} from '@mui/icons-material';
import {lighten, styled} from '@mui/material/styles/index.js';

import {getUserInitials} from './utils.js';

const Avatar = styled(MuiAvatar)(({theme, size = 'medium'}) => {
  const sizeStyles = {
    large: {
      fontSize: theme.spacing(3),
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
    medium: {
      fontSize: theme.spacing(2.5),
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    small: {
      fontSize: theme.spacing(2),
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    xsmall: {
      fontSize: theme.spacing(1.5),
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  };

  const color = theme.palette.primary.lighter;
  const mainBg = lighten(theme.palette.teal[900], 0.3);
  const accentBg = theme.palette.teal[900];

  return {
    ...sizeStyles[size],
    fontWeight: theme.typography.fontWeightMedium,
    background: `linear-gradient(138.09deg, ${mainBg} 55%, ${accentBg} 100%)`,
    color,
  };
});

/**
 * Avatar representing a logged in Planet user
 */
export const UserAvatar = ({user, ...props}) => {
  const userInitials = getUserInitials(user);

  return (
    <Tooltip
      placement="bottom"
      disableHoverListener={!user}
      title={
        user?.name || user?.email ? (
          <Fragment>
            <div>{user.name}</div>
            <div>{user.email}</div>
          </Fragment>
        ) : (
          ''
        )
      }
    >
      <Avatar data-qe="user-avatar" {...props}>
        {userInitials || <PersonIcon />}
      </Avatar>
    </Tooltip>
  );
};

UserAvatar.propTypes = {
  /**
   User object from auth
  */
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  /**
    Avatar Size
  */
  size: PropTypes.string,
};

export default memo(UserAvatar);
